(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    const progressBars = document.querySelectorAll('.carousel-progress-bar');

  progressBars.forEach((bar) => {
    const slideshowComponent = bar.closest('slideshow-component');
    if (!slideshowComponent) return;

    const scroller = slideshowComponent.querySelector('slideshow-slides');
    if (!scroller) return;

    const fill = bar.querySelector('.carousel-progress-bar__fill');
    if (!fill) return;

    function updateProgress() {
      const scrollWidth = scroller.scrollWidth;
      const clientWidth = scroller.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      // Hide progress bar if content doesn't overflow (no sliding needed)
      if (maxScroll <= 0) {
        bar.style.display = 'none';
        return;
      }

      bar.style.display = '';
      const progress = ((scroller.scrollLeft + clientWidth) / scrollWidth) * 100;
      fill.style.width = Math.min(100, Math.max(0, progress)) + '%';
    }

    // Real-time updates during drag/swipe/scroll
    scroller.addEventListener('scroll', updateProgress);

    // Arrow clicks and programmatic slide changes
    slideshowComponent.addEventListener('slideshow:select', () => {
      requestAnimationFrame(updateProgress);
    });

    // Handle resize and responsive changes
    const resizeObserver = new ResizeObserver(() => {
      updateProgress();
    });
    resizeObserver.observe(scroller);

    // Initialize: wait for in-viewport (overflow changes from hidden to scroll)
    if (slideshowComponent.hasAttribute('in-viewport')) {
      requestAnimationFrame(updateProgress);
    } else {
      const observer = new MutationObserver(() => {
        if (slideshowComponent.hasAttribute('in-viewport')) {
          observer.disconnect();
          requestAnimationFrame(updateProgress);
        }
      });
      observer.observe(slideshowComponent, { attributes: true, attributeFilter: ['in-viewport'] });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
